module.exports = __webpack_public_path__ + "img/licenzaStart.15b6ff6e.jpeg";